import { Fragment } from "react";
import { bool, string, func, object, node, oneOfType, oneOf } from "prop-types";
import { Checkbox as MuiCheckbox, FormControlLabel } from "@material-ui/core";
import { Check, Remove } from "@material-ui/icons";
import classnames from "classnames";
import useStyle from "./Checkbox.style";

export const Checkbox = ({
  checked,
  onChange,
  name,
  children,
  error,
  style,
  label,
  labelStyle,
  labelClassName,
  className,
  colorSecondary,
  uncheckedIcon,
  checkedIcon,
  indeterminateIcon,
  size="large",
  disabled = false,
  indeterminate = false,
  ...props
}) => {
  const classes = useStyle();
  const checkbox = (
    <MuiCheckbox
      {...props}
      color="primary"
      icon={uncheckedIcon || <Fragment />}
      checked={checked}
      indeterminate={indeterminate}
      name={name}
      className={classnames(
        !!error && "border-error",
        size === "small" && classes.sizeSmall,
        className
      )}
      onChange={onChange}
      inputProps={{ "aria-label": props["aria-label"] }}
      checkedIcon={checkedIcon || <Check />}
      indeterminateIcon={indeterminateIcon || <Remove />}
      style={style}
      disabled={disabled}
    />
  );

  return label ? (
    <FormControlLabel
      control={checkbox}
      style={labelStyle}
      className={classnames("m-0")}
      label={
        <p
          className={classnames(
            "ml-2",
            size === "small" ? "text-xs" : "text-md",
            size === "small" && classes.labelSmall,
            !!error && "color-error",
            colorSecondary && "text-secondary",
            labelClassName,
          )}
        >
          { label }
          { children }
        </p>
      }
    />
  ) : (
    checkbox
  );
};

Checkbox.propTypes = {
  checked: bool.isRequired,
  name: string.isRequired,
  children: node,
  error: bool,
  onChange: func,
  indeterminate: bool,
  "aria-label": string,
  style: object,
  labelStyle: object,
  disabled: bool,
  colorSecondary: bool,
  className: string,
  labelClassName: string,
  label: oneOfType([string, node]),
  uncheckedIcon: node,
  checkedIcon: node,
  indeterminateIcon: node,
  size: oneOf(["small", "large"]),
};